import { styled } from '../../Utilities';
import { getStyles } from './GroupShowAll.styles';
import { GroupShowAllBase } from './GroupShowAll.base';
export var GroupShowAll = styled(GroupShowAllBase, getStyles, undefined, {
  scope: 'GroupShowAll'
});